import { differenceInSeconds } from 'date-fns';

export function formatHMS(totalSeconds: number): string {
  const total = Math.max(0, Math.round(totalSeconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function formatRemainingTime(estimatedTime: string | null): string {
  if (!estimatedTime) {
    return '--:--:--';
  }

  const now = new Date();
  const estimatedDate = new Date(estimatedTime);

  if (estimatedDate <= now) {
    return '00:00:00';
  }

  const seconds = differenceInSeconds(estimatedDate, now);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const pad = (num: number) => num.toString().padStart(2, '0');

  return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
}
